module.exports = __webpack_public_path__ + "img\\pad_img3.0fe28eae.png";